import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import CustomModal from '../../../Modal';
import CustomTooltip from '../../../Tooltip';
import PaymentPageSettingModalComponent from '../PaymentPageSettingModal/PaymentPageSettingModal.container';
import PaymentMethodActivationComponent from '../PaymentMethodActivation/PaymentMethodActivation.container';
import { I18nFormatter } from '../../../../utils/I18n/I18n';
import { escape } from '../../../../helpers/escape';
import { useTemplateConfig } from '../../../../context/TemplateConfigContext';
import UserStore from "../../../../stores/UserStore";
import DataComponentPaymentAccounts from "../../../DataComponent/DataComponentPaymentAccounts";
import FormGroup from "../../../FormGroup";
import config from "../../../../config";

const columnTableData = {
    header: {
        7: {style: {width: 100}}
    },
    body: {}
};

const images = {
    edit: require('img/icons/icon-edit-blue.svg'),
    active: require('img/icons/icon-active-payment.svg'),
    activate: require('img/icons/icon-activate-payment.svg'),
    delete: require('img/icons/icon-delete-red.svg')
};

export const PaymentPageContainer = ({
    headerNames: propHeaderNames,
    totalPages: propTotalPages,
    loading: propLoading,
    paymentDetails: propPaymentDetails,
    paymentMethods: propPaymentMethods,
    paymentSystems: propPaymentSystems,
    allowPaymentSystems: propAllowPaymentSystems,
    countries: propCountries,
    loadingDelete: propLoadingDelete,
    deleteModalIsVisible: propDeleteModalIsVisible,
    deleteAccountTitle: propDeleteAccountTitle,
    settingModalIsVisible: propSettingModalIsVisible,
    idActivatingMethod: propIdActivatingMethod,
    getPaymentDetails: propGetPaymentDetails,
    deletePaymentAccount: propDeletePaymentAccount,
    editPaymentAccount: propEditPaymentAccount,
    t
}) => {
    const { componentOverrides = {} } = useTemplateConfig();
    const ResolvedPaymentPageSettingModalComponent = componentOverrides.PaymentPageSettingModalComponent || PaymentPageSettingModalComponent;
    const ResolvedPaymentMethodActivationComponent = componentOverrides.PaymentMethodActivationComponent || PaymentMethodActivationComponent;
    const [headerNames, setHeaderNames] = useState(propHeaderNames);
    const [totalPages, setTotalPages] = useState(propTotalPages);
    const [loading, setLoading] = useState(propLoading);
    const [paymentDetails, setPaymentDetails] = useState(propPaymentDetails);
    const [paymentMethods, setPaymentMethods] = useState(propPaymentMethods);
    const [paymentSystems, setPaymentSystems] = useState(propPaymentSystems);
    const [allowPaymentSystems, setAllowPaymentSystems] = useState(propAllowPaymentSystems);
    const [countries, setCountries] = useState(propCountries);
    const [loadingDelete, setLoadingDelete] = useState(propLoadingDelete);
    const [deleteModalIsVisible, setDeleteModalIsVisible] = useState(propDeleteModalIsVisible);
    const [deleteAccountTitle, setDeleteAccountTitle] = useState(propDeleteAccountTitle);
    const [settingModalIsVisible, setSettingModalIsVisible] = useState(propSettingModalIsVisible);
    const [idActivatingMethod, setIdActivatingMethod] = useState(propIdActivatingMethod);
    const [deleteAccountId, setDeleteAccountId] = useState(null);
    const [isSettingCreate, setIsSettingCreate] = useState(false);
    const [currentPaymentId, setCurrentPaymentId] = useState(null);

    useEffect(() => {
        setTotalPages(propTotalPages);
        setLoading(propLoading);
        setPaymentDetails(propPaymentDetails);
        setPaymentMethods(propPaymentMethods);
        setPaymentSystems(propPaymentSystems);
        setAllowPaymentSystems(propAllowPaymentSystems);
    }, [propTotalPages, propLoading, propPaymentDetails, propPaymentMethods, propPaymentSystems, propAllowPaymentSystems]);

    const onDataTableAction = useCallback((state, actionType) => {
        propGetPaymentDetails();
    }, [propGetPaymentDetails]);

    const closeDeleteModal = useCallback(() => {
        setDeleteModalIsVisible(false);
    }, []);

    const showDeleteModal = useCallback((id, title) => {
        setDeleteAccountTitle(title);
        setDeleteAccountId(id);
        setDeleteModalIsVisible(true);
    }, []);

    const showSettingModal = useCallback((isCreate, id) => {
        setSettingModalIsVisible(true);
        setIsSettingCreate(isCreate);
        setCurrentPaymentId(id);
    }, []);

    const deleteAccount = useCallback(() => {
        setLoadingDelete(true);
        propDeletePaymentAccount(deleteAccountId, onSuccessDelete);
    }, [deleteAccountId, propDeletePaymentAccount]);

    const onSuccessDelete = useCallback(() => {
        setDeleteModalIsVisible(false);
        setLoadingDelete(false);
    }, []);

    const onActivateClick = useCallback((id) => {
        setIdActivatingMethod(id);
    }, []);

    const onCancelActivateClick = useCallback(() => {
        setIdActivatingMethod(null);
    }, []);

    const onDeactivateClick = useCallback(() => {
        propEditPaymentAccount();
    }, [propEditPaymentAccount]);

    const closeSettingModal = useCallback(() => {
        setSettingModalIsVisible(false);
    }, []);

    const getStatus = useCallback((activity) => {
        const staticNames = t?.paymentPage || {};
        let status = '';

        status += activity ? staticNames.active : staticNames.notActive;

        return <span>{status}</span>;
    }, [t]);

    const getListPaymentDetails = useCallback(() => {
        if (!paymentMethods.length) return [];

        const staticNamesAction = t?.actions || {};
        let list = [];

        paymentDetails.map((payment, i) => {
            let paymentDictionary = null !== payment.payment_dictionary ? payment.payment_dictionary : null;
            const detailsNames = UserStore.getTranslation().paymentPage.details;
            let accountInfo = [];
            let accountInfoMobile = '<div class="wrap__mobile"><div class="row-title">' + staticNamesAction.accountInfo + '</div>' +
                '<div class="accountInfo__container row-value">';

            for (var key in config.paymentsInfoFieldsOrder) {
                if (payment[config.paymentsInfoFieldsOrder[key]]) {
                    accountInfo.push('<strong>' + detailsNames[key] + ':</strong> ' + payment[config.paymentsInfoFieldsOrder[key]].replaceAll('<', '&lt').replaceAll('>', '&gt'));
                    accountInfoMobile += '<div>' + detailsNames[key] + ': '+ payment[config.paymentsInfoFieldsOrder[key]].replaceAll('<', '&lt').replaceAll('>', '&gt') + '</div>';
                }
            }

            accountInfoMobile += '</div></div>';

            let rowClassName = payment.active ? 'green-bg': null;
            let statusClassName = payment.active ? "row-value green-bg" : "row-value";

            list.push({
                className: rowClassName,
                title: (
                    <div>
                        <span className="wrap__desktop">{escape(payment.title)}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{staticNamesAction.accountName}</div>
                            <div className="row-value">{escape(payment.title)}</div>
                        </div>
                    </div>
                ),
                status: (
                    <div>
                        <span className="wrap__desktop">{getStatus(payment.active)}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{staticNamesAction.paymentStatus}</div>
                            <div className={statusClassName}>
                                {getStatus(payment.active)}
                            </div>
                        </div>
                    </div>
                ),
                type: (
                    <div>
                        <span className="wrap__desktop">{paymentDictionary ? paymentDictionary.title : null}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{staticNamesAction.paymentDictionary}</div>
                            <div className="row-value">{paymentDictionary ? paymentDictionary.title : null}</div>
                        </div>
                    </div>
                ),
                currency: (
                    <div>
                        <span className="wrap__desktop">{payment.currency}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{staticNamesAction.currency}</div>
                            <div className="row-value">{payment.currency}</div>
                        </div>
                    </div>
                ),
                accountInfo: '<div class="wrap__desktop">' + accountInfo.join('<br>') + '</div>',
                accountInfoMobile: accountInfoMobile,
                createdAt: (
                    <div>
                        <span className="wrap__desktop">{I18nFormatter.fullDateTime(+payment.created_at)}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{staticNamesAction.createdAt}</div>
                            <div className="row-value">{I18nFormatter.fullDateTime(+payment.created_at)}</div>
                        </div>
                    </div>
                ),
                updatedAt: (
                    <div>
                        <span className="wrap__desktop">{I18nFormatter.fullDateTime(+payment.updated_at)}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{staticNamesAction.updatedAt}</div>
                            <div className="row-value">{I18nFormatter.fullDateTime(+payment.updated_at)}</div>
                        </div>
                    </div>
                ),
                actions: (
                    <div className="row-controls text-center d-flex justify-content-evenly">
                        {!payment.active
                            ? (
                                <React.Fragment>
                                    <CustomTooltip id={`controlActive-${i}`} tooltip={staticNamesAction.activate} containerClassName="control-item activate-button">
                                        <a className="control-item activate-button" href="#!">
                                            <span onClick={() => { onActivateClick(payment.id); }}>
                                                <img className="wrap__desktop" src={images.activate} alt=""/>
                                                 <b className="wrap__mobile">{staticNamesAction.activate}</b>
                                            </span>
                                        </a>
                                    </CustomTooltip>
                                    <CustomTooltip id={`controlEdit-${i}`} tooltip={staticNamesAction.edit} containerClassName='control-item edit-button'>
                                        <a className='control-item edit-button' href="#!">
                                            <span
                                                onClick={()=>{ showSettingModal(false, payment.id); }}
                                            ><img className="wrap__desktop" src={images.edit} alt=""/>
                                                 <b className="wrap__mobile">{staticNamesAction.edit}</b>
                                            </span>
                                        </a>
                                    </CustomTooltip>
                                    <CustomTooltip id={`controlDelete-${i}`} tooltip={staticNamesAction.delete} containerClassName='control-item delete-button'>
                                        <a className='control-item delete-button' href="#!">
                                            <span
                                                onClick={() => { showDeleteModal(payment.id, payment.title); }}
                                            ><img className="wrap__desktop" src={images.delete} alt=""/>
                                                 <b className="wrap__mobile">{staticNamesAction.delete}</b>
                                            </span>
                                        </a>
                                    </CustomTooltip>
                                </React.Fragment>
                              )
                            : (
                                <CustomTooltip id={`controlDeactivate-${i}`} tooltip={staticNamesAction.deactivate}>
                                    <a className="control-item deactivate-button" href="#!">
                                        <span
                                            onClick={onDeactivateClick}
                                        ><img className="wrap__desktop" src={images.active} alt=""/>
                                            <b className="wrap__mobile">{staticNamesAction.deactivate}</b>
                                        </span>
                                    </a>
                                </CustomTooltip>
                            )
                        }
                    </div>
                )
            });
        });

        return list;
    }, [paymentMethods, paymentDetails, t, getStatus, onActivateClick, showSettingModal, showDeleteModal, onDeactivateClick]);

    const staticNames = t?.paymentPage || {};

    let params = new URLSearchParams(window.location.search);
    if (null !== params.get('addAccount') && allowPaymentSystems.length) {
        showSettingModal(true, currentPaymentId);
        params.delete('addAccount');
        window.history.replaceState({}, '', `${location.pathname}?${params}`);
    }

    return (
        <div className="form form-payment-accounts">
            <div className="form-body data-table accounts-table">
                <CustomModal
                    visible={deleteModalIsVisible}
                    onClose={closeDeleteModal}
                    title={staticNames.deleteTitle || staticNames.title}
                    onConfirm={deleteAccount}
                    bsSize={'sm'}
                    loading={loadingDelete}
                >
                    <p>{staticNames.deleteNoty} {'«' + deleteAccountTitle + '»'}?</p>
                </CustomModal>
                <DataComponentPaymentAccounts
                    onAction={onDataTableAction}
                    totalPages={totalPages}
                    headerNames={headerNames}
                    data={getListPaymentDetails()}
                    loading={loading}
                    columnData={columnTableData}
                    className="simple-table"
                />
                <ResolvedPaymentPageSettingModalComponent
                    visible={settingModalIsVisible}
                    isCreate={isSettingCreate}
                    onClose={closeSettingModal}
                    onSubmit={closeSettingModal}
                    payment={{
                        currentPaymentId: currentPaymentId,
                        paymentMethods: paymentMethods,
                        paymentDetails: paymentDetails,
                        paymentSystems: paymentSystems,
                        allowPaymentSystems: allowPaymentSystems,
                        countries: countries
                    }}
                />
                {idActivatingMethod
                    ? (
                        <ResolvedPaymentMethodActivationComponent
                            id={idActivatingMethod}
                            onCancel={onCancelActivateClick}
                        />
                    )
                    : null
                }
            </div>
            <div className="form-footer">
                <div className="form-group">
                    <FormGroup fieldClass="save-form">
                         <button type="button" onClick={()=>{showSettingModal(true)}}
                                 className="btn apply-btn">{staticNames.addAccount}
                         </button>
                    </FormGroup>
                </div>
            </div>
        </div>
    );
};

PaymentPageContainer.propTypes = {
    headerNames: PropTypes.array,
    totalPages: PropTypes.number,
    loading: PropTypes.bool,
    paymentDetails: PropTypes.array,
    paymentMethods: PropTypes.array,
    paymentSystems: PropTypes.array,
    allowPaymentSystems: PropTypes.array,
    countries: PropTypes.array,
    loadingDelete: PropTypes.bool,
    deleteModalIsVisible: PropTypes.bool,
    deleteAccountTitle: PropTypes.string,
    settingModalIsVisible: PropTypes.bool,
    idActivatingMethod: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    getPaymentDetails: PropTypes.func,
    deletePaymentAccount: PropTypes.func,
    editPaymentAccount: PropTypes.func,
    t: PropTypes.object
};

PaymentPageContainer.defaultProps = {
    headerNames: [],
    totalPages: 0,
    loading: false,
    paymentDetails: [],
    paymentMethods: [],
    paymentSystems: [],
    allowPaymentSystems: [],
    countries: [],
    loadingDelete: false,
    deleteModalIsVisible: false,
    deleteAccountTitle: '',
    settingModalIsVisible: false,
    idActivatingMethod: null,
    getPaymentDetails: () => {},
    deletePaymentAccount: () => {},
    editPaymentAccount: () => {}
};

export default withTranslation(PaymentPageContainer);
